import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import { snakeCase } from 'lodash';
import React, { FC } from 'react';
import { CustomFieldProps, FieldStatus, FieldType } from './common';
import { SelectableField } from './SelectableField';

import styles from './MergePair.module.scss';

interface Props {
  fields: { [key: string]: FieldStatus };
  customFields: { [key: string]: FieldStatus };
  getFirstPatientValue: (fieldName: string) => string | undefined;
  getSecondPatientValue: (fieldName: string) => string | undefined;
  getFirstPatientCustomValue?: (fieldName: string) => CustomFieldProps;
  getSecondPatientCustomValue?: (fieldName: string) => CustomFieldProps;
}

export const MergePatientsResult: FC<Props> = (props) => {
  const i18next = useScopedTranslation('merge_assistant.merge_pair');
  const {
    fields,
    customFields,
    getFirstPatientValue,
    getSecondPatientValue,
    getFirstPatientCustomValue,
    getSecondPatientCustomValue,
  } = props;

  const resultFilter = (key: string) =>
    fields[key] !== FieldStatus.const &&
    fields[key] !== FieldStatus.notSelected;

  const customResultFilter = (key: string) =>
    customFields[key] !== FieldStatus.const &&
    customFields[key] !== FieldStatus.notSelected;

  return (
    <div
      className={styles.resultColumn}
      data-test-id="merge-pair-result-column"
    >
      <div className={styles.resultTitle}>{i18next.t('result')}</div>
      {Object.keys(fields).filter(resultFilter).length === 0 &&
      Object.keys(customFields).filter(customResultFilter).length === 0 ? (
        <div className={styles.emptyResultText}>{i18next.t('no_result')}</div>
      ) : (
        Object.keys(fields)
          .filter(resultFilter)
          .map((key) => {
            return (
              <SelectableField
                key={key}
                title={
                  i18next.t(`fields.${snakeCase(key)}` as any, {
                    defaultValue: key,
                  }) as string
                }
                fieldName={key}
                isSelected={false}
                className={styles.resultField}
                fieldType={FieldType.property}
                value={
                  fields[key] === FieldStatus.firstPatient
                    ? getFirstPatientValue(key)
                    : getSecondPatientValue(key)
                }
              />
            );
          })
          .concat(
            customFields &&
              getFirstPatientCustomValue &&
              getSecondPatientCustomValue
              ? Object.keys(customFields)
                  .filter(customResultFilter)
                  .map((key) => {
                    return (
                      <SelectableField
                        key={key}
                        fieldName={key}
                        title={key}
                        isSelected={false}
                        className={styles.resultField}
                        fieldType={FieldType.customField}
                        {...(customFields[key] === FieldStatus.firstPatient
                          ? getFirstPatientCustomValue(key)
                          : getSecondPatientCustomValue(key))}
                      />
                    );
                  })
              : [],
          )
      )}
    </div>
  );
};
